import script from "./InfoTooltip.vue?vue&type=script&lang=ts&setup=true"
export * from "./InfoTooltip.vue?vue&type=script&lang=ts&setup=true"

import "./InfoTooltip.vue?vue&type=style&index=0&id=c328e806&lang=css"

const __exports__ = script;

export default __exports__